/**
 * DEPT — Sticky Add To Cart bar  (v4 — mirror the REAL picker, re-query fresh)
 *
 * Why earlier versions failed to mirror in real time:
 * When you change color, Dawn's product-info.js calls updateOptionValues()
 * which runs HTMLUpdateUtility.viewTransition(this.variantSelectors, …).
 * That REPLACES the inner DOM of <variant-selects> with freshly server-
 * rendered HTML. The new size radios already carry the correct per-color
 * sold-out state (class="disabled"). But our sticky code:
 *   - cached radio element references / ids that no longer exist, and
 *   - attached a MutationObserver to the <variant-selects> element that
 *     could be torn out by the view transition, so it stopped firing.
 *
 * v4 fixes this by:
 *   1. NEVER caching radio refs — every sync re-queries the live radios
 *      fresh from the DOM by their current state.
 *   2. Reading sold-out state DIRECTLY from those real radios (Shopify
 *      already renders them correct per color), instead of recomputing
 *      from window.allVariants. The real picker is the source of truth.
 *   3. Observing the STABLE <product-info> element (which is NOT replaced)
 *      for any subtree change, plus listening to the bubbling 'change'
 *      event Dawn fires on input[name="id"], so we always re-sync after a
 *      color/size switch.
 *   4. Re-pairing sticky pills to real radios by SIZE VALUE each sync, so
 *      it survives full re-renders.
 */
(function () {
  'use strict';

  function cleanText(label) {
    if (!label) return '';
    var clone = label.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .label-unavailable').forEach(function (el) { el.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function init() {
    try {
      var bar = document.querySelector('.pulse-sticky-atc[data-section]');
      if (!bar) return;
      var sectionId = bar.dataset.section;

      var productInfo = document.getElementById('MainProduct-' + sectionId) ||
                        document.querySelector('product-info[data-section="' + sectionId + '"]') ||
                        document.querySelector('product-info');
      var mainForm = document.getElementById('product-form-' + sectionId);
      var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!mainForm || !mainBtn) return;

      var stickyBtn = bar.querySelector('.pulse-sticky-atc__btn');
      var sizeWrap = bar.querySelector('.pulse-sticky-atc__sizes');

      /* Live SIZE radios from the REAL picker — re-queried every call so we
         never hold stale refs after Dawn re-renders the picker. */
      function liveSizeRadios() {
        var picker = document.getElementById('variant-selects-' + sectionId);
        if (!picker) return [];
        return Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]')).filter(function (input) {
          return (input.getAttribute('name') || '').toLowerCase().indexOf('size') !== -1;
        });
      }

      function radioLabel(input) {
        return document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]') ||
               input.closest('label');
      }

      function radioSoldOut(input) {
        return input.disabled || input.classList.contains('disabled');
      }

      /* ---- show / hide based on main button visibility ---- */
      var watchTarget = mainBtn.closest('.product_page_buy_button') || mainBtn;
      new IntersectionObserver(function (entries) {
        var inView = entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !inView);
        document.body.style.paddingBottom = inView ? '' : (bar.offsetHeight + 'px');
      }, { threshold: 0 }).observe(watchTarget);

      /* ---- sticky ADD delegates to the real submit button, blocked when
              the real button is disabled (sold out / unavailable) ---- */
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (stickyBtn.disabled) return;
          if (mainBtn.disabled || mainBtn.hasAttribute('disabled')) return;
          mainBtn.click();
        });
      }

      /* ---- build the pills once from the initial radios ---- */
      function buildPills() {
        if (!sizeWrap) return;
        sizeWrap.innerHTML = '';
        var radios = liveSizeRadios();
        if (!radios.length) { sizeWrap.style.display = 'none'; return; }
        sizeWrap.style.display = '';
        radios.forEach(function (input) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'pulse-sticky-atc__size';
          pill.textContent = cleanText(radioLabel(input)) || input.value;
          pill.dataset.size = (input.value || '').toLowerCase();
          sizeWrap.appendChild(pill);

          pill.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (pill.disabled) return;
            // find the CURRENT live radio for this size value (fresh)
            var match = liveSizeRadios().find(function (r) {
              return (r.value || '').toLowerCase() === pill.dataset.size;
            });
            if (!match || radioSoldOut(match)) return;
            if (!match.checked) {
              match.checked = true;
              match.dispatchEvent(new Event('change', { bubbles: true }));
            }
            var lab = radioLabel(match);
            if (lab) lab.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            // re-sync after Dawn processes the change
            setTimeout(syncAll, 80);
          });
        });
      }

      /* ---- mirror real radios' sold-out + selected state onto the pills,
              and mirror the real submit button onto the sticky button ---- */
      function syncPills() {
        if (!sizeWrap) return;
        var radios = liveSizeRadios();
        var bySize = {};
        radios.forEach(function (r) { bySize[(r.value || '').toLowerCase()] = r; });

        sizeWrap.querySelectorAll('.pulse-sticky-atc__size').forEach(function (pill) {
          var r = bySize[pill.dataset.size];
          if (!r) { pill.classList.add('is-soldout'); pill.disabled = true; return; }
          var soldOut = radioSoldOut(r);
          pill.classList.toggle('is-soldout', soldOut);
          pill.disabled = soldOut;
          pill.classList.toggle('is-selected', !!r.checked);
        });
      }

      function syncButton() {
        if (!stickyBtn) return;
        var mainText = mainBtn.querySelector('span');
        if (mainText) {
          var t = (mainText.textContent || '').trim();
          if (t) stickyBtn.textContent = t;
        }
        var disabled = mainBtn.disabled || mainBtn.hasAttribute('disabled');
        stickyBtn.disabled = disabled;
        bar.classList.toggle('is-disabled', disabled);
      }

      function syncAll() {
        try { syncPills(); syncButton(); } catch (e) { console.error('[DEPT sticky] syncAll', e); }
      }

      buildPills();
      syncAll();

      /* ---- triggers that re-sync ---- */

      // Dawn dispatches a bubbling 'change' on input[name="id"] after every
      // variant update (see product-info.js updateVariantInputs).
      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('input[name="id"], #variant-selects-' + sectionId + ' input[type="radio"]')) {
          setTimeout(syncAll, 40);
        }
      });

      // Observe the STABLE <product-info> wrapper (NOT the variant-selects,
      // which gets replaced). Any re-render of the picker subtree, price,
      // or submit button bubbles up here — then we re-sync. If the pills set
      // itself looks stale (size set changed), rebuild them.
      if (productInfo) {
        var rerenderTimer = null;
        new MutationObserver(function () {
          clearTimeout(rerenderTimer);
          rerenderTimer = setTimeout(function () {
            // If the live size set differs from our pills, rebuild.
            var liveSizes = liveSizeRadios().map(function (r) { return (r.value || '').toLowerCase(); }).join(',');
            var pillSizes = Array.prototype.slice.call(sizeWrap ? sizeWrap.querySelectorAll('.pulse-sticky-atc__size') : [])
              .map(function (p) { return p.dataset.size; }).join(',');
            if (liveSizes && liveSizes !== pillSizes) buildPills();
            syncAll();
          }, 50);
        }).observe(productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
      }

      // Belt-and-suspenders: also poll briefly after any click inside the
      // real picker (covers edge themes that mutate without bubbling).
      var picker0 = document.getElementById('variant-selects-' + sectionId);
      if (picker0) {
        picker0.addEventListener('click', function () { setTimeout(syncAll, 120); });
      }
    } catch (err) {
      console.error('[DEPT sticky] init', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
